var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ScoringSurveyAccessLinks", {
        attrs: { viewModel: _vm.scoringSurveyAccessLinks },
        on: {
          "show-email-sender": _vm.handleShowEmailSender,
          "download-links": _vm.handleDownloadAccessLinks,
        },
      }),
      _vm._v(" "),
      _c("ScoringSurveyEmailSender", {
        attrs: { viewModel: _vm.scoringSurveyEmailSender },
        on: { "send-email": _vm.handleSendEmailCommand },
      }),
      _vm._v(" "),
      _c("SurveyOpenerDialog", {
        attrs: {
          propOpened: _vm.surveyOpenerSurveyId != null,
          propSurveyId: _vm.surveyOpenerSurveyId,
        },
        on: {
          "start-survey": _vm.handleStartSurveyCommand,
          "show-access-links": _vm.showAccessLinks,
          "close-dialog": function ($event) {
            _vm.surveyOpenerSurveyId = null
          },
        },
      }),
      _vm._v(" "),
      _c("SurveyCloserDialog", {
        attrs: {
          propOpened: _vm.surveyCloserSurveyId != null,
          propSurveyId: _vm.surveyCloserSurveyId,
        },
        on: {
          "stop-survey": _vm.handleStopSurveyCommand,
          "close-dialog": function ($event) {
            _vm.surveyCloserSurveyId = null
          },
        },
      }),
      _vm._v(" "),
      _c("SurveyAlternativesManagerDialog", {
        attrs: { viewModel: _vm.surveyAlternativesManagerDialog },
        on: {
          "preview-description": _vm.handleLoadAlternativeDescription,
          "load-alternatives": _vm.handleLoadAlternativesByList,
          "save-survey": _vm.handleUpdateSurveyAlternativesCommand,
        },
      }),
      _vm._v(" "),
      _c("SurveyCriteriaManagerDialog", {
        attrs: { viewModel: _vm.surveyCriteriaManagerDialog },
        on: { "update-survey-criteria": _vm.handleUpdateSurveyCriteriaCommand },
      }),
      _vm._v(" "),
      _c("SubSurveysManagerDialog", {
        attrs: { viewModel: _vm.subSurveysManagerDialog },
        on: {
          "include-sub-survey": _vm.handleIncludeSubSurveyCommand,
          "exclude-sub-survey": _vm.handleExcludeSubSurveyCommand,
          "change-vote-strength": _vm.handleChangeSubSurveyVoteStrengthCommand,
        },
      }),
      _vm._v(" "),
      _c("SurveyEditorDialog", {
        attrs: { viewModel: _vm.surveyEditorDialog },
        on: {
          "delete-survey": _vm.handleDeleteSurveyCommand,
          "create-survey": _vm.handleCreateSurveyCommand,
          "update-survey": _vm.handleUpdateSurveyCommand,
        },
      }),
      _vm._v(" "),
      _c("ScoresExporter", {
        attrs: { viewModel: _vm.scoresExporter },
        on: {
          "show-attribute-creator": _vm.showAttributeCreator,
          "load-preview": _vm.loadScoresExporterPreview,
          "reset-preview": _vm.resetScoresExporterPreview,
          "export-scores": _vm.handleExportSurveyScoresToAttributesCommand,
          "close-dialog": _vm.closeScoresExporter,
        },
      }),
      _vm._v(" "),
      _c("AttributeEditorDialog", {
        attrs: { viewModel: _vm.attributeEditorDialog },
        on: { "numeric-attribute-created": _vm.numericAttributeCreated },
      }),
      _vm._v(" "),
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          !_vm.rm
            ? _c("h3", [
                _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                _vm._v(" Loading... "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.rm
            ? _c(
                "div",
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("h3", [_vm._v("Goal: " + _vm._s(_vm.rm.GoalName))]),
                  _c("br"),
                  _vm._v(" "),
                  _c("GoalNavigation", {
                    attrs: {
                      WorkspaceId: _vm.workspaceId,
                      ProjectId: _vm.projectId,
                      EvalModelId: _vm.evalModelId,
                      ActivePage: "scoring-surveys",
                      ScoringEnabled: true,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      attrs: { role: "button" },
                      on: { click: _vm.showSurveyCreator },
                    },
                    [
                      _vm._v(
                        "\n                Create opinion panel\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { role: "button" },
                      on: {
                        click: _vm.handleExportAllScoringVotesToXlsCommand,
                      },
                    },
                    [_vm._v("\n                Export votes\n            ")]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.surveysView, function (s) {
                      return _c(
                        "div",
                        {
                          key: s.Id,
                          staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12",
                        },
                        [
                          _c("div", { staticClass: "card mt-2" }, [
                            _c("div", { staticClass: "card-body" }, [
                              _c("h5", { staticClass: "card-title" }, [
                                s.SurveyStarted === false
                                  ? _c("i", {
                                      staticClass: "fa fa-lock text-danger",
                                      attrs: { title: "Survey is closed" },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                s.SurveyStarted === true
                                  ? _c("i", {
                                      staticClass:
                                        "fa fa-unlock-alt text-success",
                                      attrs: { title: "Survey is open" },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(s.Name))]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col text-nowrap" }, [
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "sanitizedHref",
                                          rawName: "v-sanitizedHref",
                                          value: `/#/pp/scoring-panelists/${_vm.workspaceId}/${_vm.projectId}/${_vm.evalModelId}/${s.Id}`,
                                          expression:
                                            "`/#/pp/scoring-panelists/${workspaceId}/${projectId}/${evalModelId}/${s.Id}`",
                                        },
                                      ],
                                      staticClass: "text-primary",
                                    },
                                    [
                                      _vm._v(
                                        "Panelists: " +
                                          _vm._s(s.RespondentsCount)
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col text-nowrap" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-primary",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showSubSurveysManager(s.Id)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Combined panels:  " +
                                          _vm._s(s.SubSurveysCount)
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col text-nowrap" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-primary",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showSurveyCriteriaManager(
                                            s.Id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Criteria: " +
                                          _vm._s(s.CriteriaCount) +
                                          "/" +
                                          _vm._s(_vm.rm.CriteriaCount)
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col text-nowrap" }, [
                                  _c("span", [
                                    _vm._v(
                                      "Questions: " + _vm._s(s.QuestionsCount)
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col text-nowrap" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-primary",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showSurveyAlternativesManager(
                                            s.Id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.rm.AlternativesLabel) +
                                          ": " +
                                          _vm._s(s.AlternativesCount) +
                                          "/" +
                                          _vm._s(_vm.rm.AlternativesCount) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              s.HasQuestions === true
                                ? _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "sanitizedHref",
                                          rawName: "v-sanitizedHref",
                                          value: `/#/pp/scoring-review/${_vm.workspaceId}/${_vm.projectId}/${_vm.evalModelId}/${s.Id}`,
                                          expression:
                                            "`/#/pp/scoring-review/${workspaceId}/${projectId}/${evalModelId}/${s.Id}`",
                                        },
                                      ],
                                      staticClass:
                                        "btn btn-sm btn-outline-secondary",
                                    },
                                    [_vm._v("Review")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              s.HasQuestions === false
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-sm btn-outline-secondary",
                                      attrs: { disabled: "" },
                                    },
                                    [_vm._v("Review")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dropdown d-inline-block" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-sm btn-outline-secondary dropdown-toggle",
                                      attrs: {
                                        type: "button",
                                        "data-toggle": "dropdown",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Actions\n                                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "dropdown-menu" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.showSurveyEditor(s)
                                          },
                                        },
                                      },
                                      [_vm._v("Edit")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "dropdown-divider",
                                    }),
                                    _vm._v(" "),
                                    s.SurveyStarted === false
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showSurveyOpener(
                                                  s.Id
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Open survey")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    s.SurveyStarted === true
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showSurveyCloser(
                                                  s.Id
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Close survey")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "dropdown-divider",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.showScoresExporter(s.Id)
                                          },
                                        },
                                      },
                                      [_vm._v("Save scores")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "dropdown-divider",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.confirmSurveyDelete(s)
                                          },
                                        },
                                      },
                                      [_vm._v("Delete")]
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      {
        staticClass: "btn btn-outline-secondary float-right",
        attrs: {
          href: "https://www.transparentchoice.com/user-guide/pick-a-winner",
          title: "User guide: Pick a winner",
          target: "_blank",
        },
      },
      [_c("i", { staticClass: "fa fa-info", attrs: { "aria-hidden": "true" } })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }